export const FETCH_SEARCH_RESULTS = 'FETCH_SEARCH_RESULTS';
export const RECEIVE_SEARCH_RESULTS = 'RECEIVE_SEARCH_RESULTS';
export const MODIFY_FILTERS = 'MODIFY_FILTERS';
export const SEARCH_RESULTS_HAS_ERRORED = 'SEARCH_RESULTS_HAS_ERRORED';
export const SEARCH_RESULTS_IS_LOADING = 'SEARCH_RESULTS_IS_LOADING';
export const FETCH_PRESET_FILTERS_IS_LOADING = 'FETCH_PRESET_FILTERS_IS_LOADING';
export const FETCH_COLUMN_PRESETS_IS_LOADING = 'FETCH_COLUMN_PRESETS_IS_LOADING';
export const SAVE_PRESET_FILTERS_IS_LOADING = 'SAVE_PRESET_FILTERS_IS_LOADING';
export const UPDATE_PRESET_FILTERS_IS_LOADING = 'UPDATE_PRESET_FILTERS_IS_LOADING';
export const DELETE_PRESET_FILTERS_IS_LOADING = 'DELETE_PRESET_FILTERS_IS_LOADING';
export const COLUMN_PRESET_SAVE_IS_LOADING = 'COLUMN_PRESET_SAVE_IS_LOADING';
export const SEARCH_RESULTS_FETCH_DATA_SUCCESS = 'SEARCH_RESULTS_FETCH_DATA_SUCCESS';
export const PRESET_FILTERS_FETCH_DATA_SUCCESS = 'PRESET_FILTERS_FETCH_DATA_SUCCESS';
export const PRESET_FILTER_SAVE_SUCCESS = 'PRESET_FILTER_SAVE_SUCCESS';
export const TOTAL_EVENTS_FETCH_SUCCESS = 'TOTAL_EVENTS_FETCH_SUCCESS';
export const CURRENT_PAGE_FETCH_SUCCESS = 'CURRENT_PAGE_FETCH_SUCCESS';
export const HANDLE_LOAD_FILTERS = 'HANDLE_LOAD_FILTERS';
export const HANDLE_SAVE_FILTERS = 'HANDLE_SAVE_FILTERS';
export const SHOW_PRESET_FILTER_OP_BUTTON = 'SHOW_PRESET_FILTER_OP_BUTTON';
export const SHOW_COLUMN_PRESET_OP_BUTTON = 'SHOW_COLUMN_PRESET_OP_BUTTON';
export const HANDLE_PRESET_FILTER_OP_SELECT_CHANGE = 'HANDLE_PRESET_FILTER_OP_SELECT_CHANGE';
export const HANDLE_COLUMN_PRESET_OP_SELECT_CHANGE = 'HANDLE_COLUMN_PRESET_OP_SELECT_CHANGE';
export const PRESET_FILTER_UPDATE_BUTTON_ENABLED = 'PRESET_FILTER_UPDATE_BUTTON_ENABLED';
export const PRESET_FILTER_DELETE_BUTTON_ENABLED = 'PRESET_FILTER_DELETE_BUTTON_ENABLED';
export const PRESET_FILTER_LOAD_BUTTON_ENABLED = 'PRESET_FILTER_LOAD_BUTTON_ENABLED';
export const COLUMN_PRESET_LOAD_BUTTON_ENABLED = 'COLUMN_PRESET_LOAD_BUTTON_ENABLED';
export const COLUMN_PRESET_SAVE_BUTTON_ENABLED = 'COLUMN_PRESET_SAVE_BUTTON_ENABLED';
export const PRESET_FILTER_OP_MODAL_LOADING = 'PRESET_FILTER_OP_MODAL_LOADING';
export const TRIGGER_UPDATE_FORM_VALUES = 'TRIGGER_UPDATE_FORM_VALUES';
export const PRESET_FILTER_UPDATE_SUCCESS = 'PRESET_FILTER_UPDATE_SUCCESS';
export const PRESET_FILTER_DELETE_SUCCESS = 'PRESET_FILTER_DELETE_SUCCESS';
export const SNACKBAR_IS_OPEN = 'SNACKBAR_IS_OPEN';
export const SET_SNACKBAR_MESSAGE = 'SET_SNACKBAR_MESSAGE';
export const CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE';
export const RELOAD_ALL_FILTERS = 'RELOAD_ALL_FILTERS';
export const RELOAD_ALL_COLUMN_PRESETS = 'RELOAD_ALL_COLUMN_PRESETS';
export const COLUMN_NAMES_CHANGE = 'COLUMN_NAMES_CHANGE';
export const HANDLE_LOAD_COLUMN_PRESETS = 'HANDLE_LOAD_COLUMN_PRESETS';
export const HANDLE_SAVE_COLUMN_PRESETS = 'HANDLE_SAVE_COLUMN_PRESETS';
export const HANDLE_DELETE_COLUMN_PRESETS = 'HANDLE_DELETE_COLUMN_PRESETS';
export const SET_COLUMN_PRESET_NAME = 'SET_COLUMN_PRESET_NAME';
export const PRESET_FILTERS_FETCH_HAS_ERRORED = 'PRESET_FILTERS_FETCH_HAS_ERRORED';
export const COLUMN_PRESET_FETCH_DATA_SUCCESS = 'COLUMN_PRESET_FETCH_DATA_SUCCESS';
export const COLUMN_PRESET_LOAD_BUTTON_VISIBLE = 'COLUMN_PRESET_LOAD_BUTTON_VISIBLE';
export const COLUMN_PRESET_SAVE_BUTTON_VISIBLE = 'COLUMN_PRESET_SAVE_BUTTON_VISIBLE';
export const COLUMN_PRESET_LOAD_MODAL_LOADING = 'COLUMN_PRESET_LOAD_MODAL_LOADING';
export const PULL_NOW_POST_IN_PROGRESS = 'PULL_NOW_POST_IN_PROGRESS';
export const HANDLE_SELECTION_CHANGE = 'HANDLE_SELECTION_CHANGE';
export const INVENTORY_TAG_FETCH_SUCCESS = 'INVENTORY_TAG_FETCH_SUCCESS';
export const SUB_GENRE_UPDATE_SUCCESS = 'SUB_GENRE_UPDATE_SUCCESS';
export const HANDLE_EDIT_NOTIFICATIONS = 'HANDLE_EDIT_NOTIFICATIONS';
export const HANDLE_TOGGLE_FILTERS = 'HANDLE_TOGGLE_FILTERS';
export const NOTIFICATION_SWITCH_ACTIVE = 'NOTIFICATION_SWITCH_ACTIVE';
export const COLUMN_PRESET_DEFAULT_BUTTON_ENABLED = 'COLUMN_PRESET_DEFAULT_BUTTON_ENABLED';
export const COLUMN_ORDER_CHANGE = 'COLUMN_ORDER_CHANGE';
export const FETCH_NOTIFICATIONS_NAV_BAR_SUCCESS = 'FETCH_NOTIFICATIONS_NAV_BAR_SUCCESS';
export const COLUMN_WIDTH_CHANGE = 'COLUMN_WIDTH_CHANGE';
export const COLUMN_PINNED_CHANGE = 'COLUMN_PINNED_CHANGE';
export const LIMITSHEET_IS_LOADING = 'LIMITSHEET_IS_LOADING';
export const LIMITSHEET_URL = 'LIMITSHEET_URL';
export const LIMITSHEET_SUCCESS_OPEN = 'LIMITSHEET_SUCCESS_OPEN';
export const WHOS_NAME_CHANGE = 'WHOS_NAME_CHANGE';
export const LIMITSHEET_TITLE = 'LIMITSHEET_TITLE';
export const INFO_SNACKBAR_OPEN = 'INFO_SNACKBAR_OPEN';
export const EVENT_SEARCH_ROW_SELECTED = 'EVENT_SEARCH_ROW_SELECTED';
export const SHOW_SAVE_FILTERS_BUTTON = 'SHOW_SAVE_FILTERS_BUTTON';
export const SHOW_SAVE_COLUMNS_BUTTON = 'SHOW_SAVE_COLUMNS_BUTTON';
export const EVENT_TAGS_FETCH_SUCCESS = 'EVENT_TAGS_FETCH_SUCCESS';
